import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { Subject } from "rxjs/internal/Subject";
import { PanelLocationsService } from "../../../../locations-map/services/Panel-Locations.service";
import { PanelDetailGeofencesService } from "../../../../geofences-map/services/Panel-Detail-Geofences.service";
import { PanelDetailLocationsService } from "../../../../locations-map/services/Panel-Detail-Locations.service";
import { PanelResumeRouteService } from "../../../../routeMap/services/Panel-Resume-Route.service";
import { RouteFilterService } from "../../../../routeMap/services/Route-Filter.service";
import { RouteMapService } from "../../../../routeMap/services/Route-Map.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { NotificationsAPIService } from "../../../services/API/NotificationsAPI.service";
import { NotificationDTO } from "../../../../notifications/models/NotificationDTO";
import { AlarmAPIService } from "../../../services/API/AlarmAPI.service";
import { GeofencesService } from "../../../../geofences-map/services/Geofences.service";

@Injectable({
  providedIn: "root",
})
export class NavHeaderService {
  public pushedClassSelected: string;
  isLocationSelected: boolean;
  isRoutesSelected: boolean;
  isGeofencesSelected: boolean;
  
  selectedPanel: any;
  private isLocationSelected$: Subject<boolean> = new Subject();
  private isRoutesSelected$: Subject<boolean> = new Subject();
  private isGeofencesSelected$: Subject<boolean> = new Subject();
  private pushedClassSelected$: Subject<string> = new Subject();

  suscription_SelectedPanel: Subscription;

  constructor(
    private panelLocationsService: PanelLocationsService,
    private panelDetalilService: PanelDetailLocationsService,
    private routeMapFilterService: RouteFilterService,
    private panelResumeService: PanelResumeRouteService,
    private geofencesMapService: GeofencesService,
    private panelDetailGeofences: PanelDetailGeofencesService,
    private GeofencesServices: GeofencesService,
    private routeMapService: RouteMapService,
    private route: ActivatedRoute
  ) {}

  checkPanelsVisibility() {
    console.log("locations", this.isLocationSelected);
    console.log("routes", this.isRoutesSelected);
    console.log("geofences", this.isGeofencesSelected);
    if (this.isLocationSelected) {
      //cierra detalle y abre locations
      this.panelLocationsService.setVisibilityPanel(true);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.hiddenRouteMapLayers();


      //cierra Geofences
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

    } else if (this.isRoutesSelected) {
      //cierra resumen de ruta y abre Routes
      this.routeMapFilterService.setVisibilityPanel(true);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.hiddenRouteMapLayers();


      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Geofences
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.panelDetailGeofences.setVisibilityPopup(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);
    } else if (this.isGeofencesSelected) {
      //cierra todo lo relacionado con geocercas excepto Geofences
      this.geofencesMapService.setVisiblePanelGeofences(true);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      //cierra Locations
      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      //cierra Routes
      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.hiddenRouteMapLayers();

    }else{
      //cierra todo
      this.geofencesMapService.setVisiblePanelGeofences(false);
      this.GeofencesServices.setVisiblePanelEditGeofences(false);
      this.GeofencesServices.setVisiblePanelDetailGeofences(false);

      this.panelLocationsService.setVisibilityPanel(false);
      this.panelDetalilService.setVisibilityPopup(false);

      this.routeMapFilterService.setVisibilityPanel(false);
      this.panelResumeService.setVisibilityPopup(false);
      this.routeMapService.hiddenRouteMapLayers();
    }
  }

  setIsLocationSelected(resp) {
    this.isLocationSelected = true;
    this.isRoutesSelected = false;
    this.isGeofencesSelected = false;
    this.isLocationSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsRoutesSelected() {
    return this.isRoutesSelected$.asObservable();
  }

  getPushedClass() {
    return this.pushedClassSelected$.asObservable();
  }

  setPushedClass() {
    if (this.isLocationSelected) {
      this.pushedClassSelected = "locationsMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
    if (this.isRoutesSelected) {
      this.pushedClassSelected = "routingMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
    if (this.isGeofencesSelected) {
      this.pushedClassSelected = "geofencesMapImHere";
      this.pushedClassSelected$.next(this.pushedClassSelected);
    }
  }

  setIsRoutesSelected(resp) {
    this.isRoutesSelected = true;
    this.isLocationSelected = false;
    this.isGeofencesSelected = false;
    this.isRoutesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsLocationSelected() {
    return this.isLocationSelected$.asObservable();
  }

  setIsGeofencesSelected(resp) {
    this.isGeofencesSelected = true;
    this.isRoutesSelected = false;
    this.isLocationSelected = false;
    this.isGeofencesSelected$.next(resp);
    this.checkPanelsVisibility();
  }

  getIsGeofencesSelected() {
    return this.isGeofencesSelected$.asObservable();
  }

  closeAllPanels() {
    this.isLocationSelected = false;
    this.isLocationSelected$.next(false);
    this.isRoutesSelected = false;
    this.isRoutesSelected$.next(false);
    this.isGeofencesSelected = false;
    this.isGeofencesSelected$.next(false);
    this.checkPanelsVisibility();
  }

  CheckMapPaneles() {
    if (this.suscription_SelectedPanel) this.suscription_SelectedPanel.unsubscribe();
    
    this.suscription_SelectedPanel = this.route.queryParams
    .subscribe(params => {
      this.selectedPanel = params.selectedPanel;
      console.log("selectedPanel params", params);
      if(this.selectedPanel == "locationsMap"){
        this.setIsLocationSelected(true);
      }else if( this.selectedPanel == "routingMap"){
        this.setIsRoutesSelected(true);
      }else if(this.selectedPanel == "geofencesMap"){
        this.setIsGeofencesSelected(true);
      }
    });
  }

}
